import { useTheme } from '@context/ThemeContext'
import { useLanguage } from '@context/LanguageContext'
import { SunIcon, MoonIcon } from '../Icons'
import styles from './ThemeSelector.module.css'

export default function ThemeSelector () {
  const { theme, toggleTheme } = useTheme()
  const { t } = useLanguage()

  const isLight = theme === 'light'
  const label = isLight ? t.core.access.themeSwitch.dark : t.core.access.themeSwitch.light

  return (
    <button
      onClick={toggleTheme}
      className={styles.btn}
      aria-label={label}
      title={label}
    >
      {isLight
        ? (
          <MoonIcon size={20} stroke={1.5} aria-hidden='true' />
          )
        : (
          <SunIcon size={20} stroke={1.5} aria-hidden='true' />
          )}
    </button>
  )
}
